module.exports = __webpack_public_path__ + "media/images/fancybox_sprite@2x-89fa20c7590c9538072a2b6bde598920.png";